export const social = {
  linkedin: 'https://www.linkedin.com/company/10896758',
  youtube: 'https://www.youtube.com/channel/UCb6NwXGwNOg_D13XP7UJEaQ'
};

export const logo = '/images/brand/logo.webp';
